<template>

  <div class="wrapper">
    <div class="sidebar" data-color="blue" data-image="../assets/img/sidebar-5.jpg">
      <!--
          Tip 1: You can change the color of the sidebar using: data-color="purple | blue | green | orange | red"

          Tip 2: you can also add an image using data-image tag
      -->
      <div class="sidebar-wrapper">
        <div class="logo">
          <a href="#" class="simple-text logo-mini">R</a>
          <a href="#" class="simple-text logo-normal">RAEFTON</a>
        </div>

        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link" href="/raw_templates/t_dashboard">
              <i class="nc-icon nc-delivery-fast"></i>
              <p>RFQs</p>
            </a>
          </li>
          <li class="nav-item active ">
            <a class="nav-link" href="/raw_templates/t_createrfq">
              <i class="nc-icon nc-paper-2"></i>
              <p>CREATE RFQ</p>
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link" href="/raw_templates/t_contacts">
              <i class="nc-icon nc-circle-09"></i>
              <p>CONTACTS</p>
            </a>
          </li>

        </ul>
      </div>
      <div class="sidebar-background" style="background-image: url(/static/img/sidebar-5.jpg) "></div>
    </div>
    <div class="main-panel">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-minimize">
              <button id="minimizeSidebar" class="btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block">
                <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i class="fa fa-navicon visible-on-sidebar-mini"></i>
              </button>
            </div>
            <a class="navbar-brand" href="#pablo">Create RFQ</a>
          </div>
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
          </button>

        </div>
      </nav>
      <!-- End Navbar -->
      <div class="content">

        <div class="row">
          <div class="col">
            <div class="card-columns">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Customer</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col">
                      <div class="form-group">
                        <label for="customer_co">Company / Name</label>
                        <input type="text" class="form-control" id="customer_co" placeholder="">
                      </div>
                      <div class="form-group">
                        <label for="customer_co">Terms</label>
                        <select name="customer_terms" class="form-control">
                          <option value="id">EXW Ex-works</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="customer_co">Due Date</label>
                        <div class="form-group">
                          <input id="datetimepicker" type="text" class="form-control datetimepicker" >
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        86 Edwin Street
                        <br> Kitchener, Ontario
                        <br> K0A 2N0
                        <br> Canada
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Shipper</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col">
                      <div class="form-group">
                        <label for="shipper_co">Company / Name</label>
                        <input type="text" class="form-control" id="shipper_co" placeholder="">
                      </div>
                      <div class="form-group">
                        <label for="datetimepicker">Pick Up</label>
                        <div class="form-group">
                          <input id="datetimepicker" type="text" class="form-control datetimepicker" >
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="shipper_appt">Appointment</label>
                        <select name="shipper_appt" class="form-control">
                          <option value="id">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="col">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        86 Edwin Street
                        <br> Kitchener, Ontario
                        <br> K0A 2N0
                        <br> Canada
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Assignees</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Due Date</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>John Valence</td>
                            <td>11/02/2018</td>
                            <td class="text-right"><button class="btn btn-icon btn-xs btn-danger"><i class="fa fa-minus"></i></button></td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-group">
                                <input type="text" id="assignee_name" class="form-control">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input id="datetimepicker" type="text" class="form-control datetimepicker" >
                              </div>
                            </td>
                            <td class="text-right"><button class="btn btn-icon btn-xs btn-success"><i class="fa fa-plus"></i></button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Consignee</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="consignee_co">Company / Name</label>
                            <input type="text" class="form-control" id="consignee_co" placeholder="">
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="datetimepicker">Delivery</label>
                            <div class="form-group">
                              <input id="datetimepicker" type="text" class="form-control datetimepicker" >
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label for="customer_co">Appointment</label>
                            <select name="customer_terms" class="form-control">
                              <option value="id">No</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label for="customer_co">COD</label>
                            <select name="customer_terms" class="form-control">
                              <option value="id">No</option>
                            </select>
                          </div>
                        </div>
                      </div>



                    </div>
                    <div class="col">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        86 Edwin Street
                        <br> Kitchener, Ontario
                        <br> K0A 2N0
                        <br> Canada
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Truck</h4>
              </div>
              <div class="card-body">
                <div class="form row">
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_trailertype">Trailer Type</label>
                      <select name="truck_trailertype" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_suspensiontype">Suspension Type</label>
                      <select name="truck_suspensiontype" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_temperaturecontrol">Temperature Control</label>
                      <select name="truck_temperaturecontrol" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_liftgate">Lift Gate</label>
                      <select name="truck_liftgate" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_driverassist">Driver Assist</label>
                      <select name="truck_driverassist" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_mode">Mode</label>
                      <select name="truck_mode" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_service">Service</label>
                      <select name="truck_service" class="form-control">
                        <option value="id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_trailertype">Dunnage Required</label>
                      <input type="number" class="form-control">
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-8 col-md-6">
                    <div class="form-group">
                      <label for="truck_special">Special Instructions</label>
                      <textarea name="truck_special" id="truck_special" class="form-control" cols="30" rows="10"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="alert alert-warning text-center d-flex justify-content-between align-items-center">
              <div><h4 class="m-0"><span class="small text-white">Density</span> <strong class="pr-4">160 lbs / cubic ft</strong> <span class="small text-white">Class</span> <strong>75</strong></h4></div>
              <!-- <div><button class="btn btn-primary">Add Shipping Unit</button></div> -->
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Shipping Unit</h4>
              </div>
              <div class="card-body">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="disabled-sorting"></th>
                      <th>Description</th>
                      <th>Type</th>
                      <th class="text-right">Quantity</th>
                      <th class="text-right">Length</th>
                      <th class="text-right">Width</th>
                      <th class="text-right">Height</th>
                      <th class="disabled-sorting">Unit</th>
                      <th class="text-right">Weight</th>
                      <th class="disabled-sorting">Unit</th>
                      <th>Stackable</th>
                      <th>Hazardous</th>
                      <th class="disabled-sorting text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>#1</td>
                      <td>lorem ipsum dolor sit amet</td>
                      <td>Skid</td>
                      <td class="text-right">2</td>
                      <td class="text-right">48</td>
                      <td class="text-right">48</td>
                      <td class="text-right">48</td>
                      <td>Inches</td>
                      <td class="text-right">1000</td>
                      <td>lbs</td>
                      <td>Yes</td>
                      <td><a href="#">Yes</a></td>
                      <td class="nowrap text-right"><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                    </tr>
                    <tr>
                      <td>#2</td>
                      <td><input type="text" class="form-control"></td>
                      <td>
                        <select id="shipping_type" class="form-control"><option>None</option> <option>Pallet</option> <option value="Skid" selected="selected">Skid</option> <option>Slipsheet</option> <option>Tote</option> <option>Pallet Box</option> <option>Skid Box</option> <option>Bin</option> <option>Basket</option> <option>Rack</option> <option>Carton</option> <option>Bag</option> <option>Drum</option> <option>Crate</option></select>
                      </td>
                      <td class="text-right"><input type="number" class="form-control"></td>
                      <td class="text-right"><input type="number" class="form-control"></td>
                      <td class="text-right"><input type="number" class="form-control"></td>
                      <td class="text-right"><input type="number" class="form-control"></td>
                      <td><select id="suunitlength" class="form-control"><option>Inches</option> <option>Millimeters</option></select></td>
                      <td class="text-right"><input type="number" class="form-control"></td>
                      <td><select id="suunitweight" class="form-control"><option>Pounds</option> <option>Grams</option></select></td>
                      <td><select id="shipping_stackable" class="form-control"><option id="stackabledefault">No</option> <option>Yes</option></select></td>
                      <td><select id="shipping_hazardous" class="form-control"><option id="stackabledefault">No</option> <option>Yes</option></select></td>
                      <td class="nowrap text-right"><a href="#" class="btn btn-primary"><i class="fa fa-plus"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-trash"></i></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-simple btn-link btn-wd"><i class="fa fa-times"></i> Cancel</button> <button class="btn btn-primary btn-wd"><i class="fa fa-save"></i> Save</button>
        </div>
      </div>
      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2018 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>

</template>

<!-- MODAL FOR WHEN HAZARDOUS = YES -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Hazardous</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="cargo1_packinginstructions">Packing Instructions</label>
              <input type="text" id="cargo1_packinginstructions" placeholder="Only required if you selected yes to Hazardous" name="website" class="form-control">
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="cargo1_un1">UN #</label> <input type="text" id="cargo1_un1" placeholder="" class="form-control">
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="cargo1_class">Class</label> <input type="text" id="cargo1_class" placeholder="" class="form-control">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
<!-- <script type="text/javascript">
    $(document).ready(function() {
        $('#datatables').DataTable({
            "pagingType": "full_numbers",
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            responsive: true,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search records",
            }

        });


        var table = $('#datatables').DataTable();

        // Edit record
        table.on('click', '.edit', function() {
            $tr = $(this).closest('tr');

            if ($tr.hasClass('child')) {
                $tr = $tr.prev('.parent');
            }

            var data = table.row($tr).data();
            alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
        });

        // Delete a record
        table.on('click', '.remove', function(e) {
            $tr = $(this).closest('tr');
            table.row($tr).remove().draw();
            e.preventDefault();
        });

        //Like record
        table.on('click', '.like', function() {
            alert('You clicked on Like button');
        });
    });
</script> -->
<script>
  import router from '../../router'
  import apiService from '../../services/api.service'
  import config from '../../config'

  import "../../../static/js/bootstrap-datetimepicker.js"


  export default {
    name: 'Demo',
    data: function() {
      return {
        user: '',
        password: '',
        myname: 'Timmyy',
      }
    },
    mounted: function() {
      console.log("------------------mounted");
      initDates();
    },
    methods: {


    }
  }



  function initDates() {
    console.log("-----------------init dates...");
    $('.datetimepicker').datetimepicker({
      icons: {
        time: "fa fa-clock-o",
        date: "fa fa-calendar",
        up: "fa fa-chevron-up",
        down: "fa fa-chevron-down",
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-screenshot',
        clear: 'fa fa-trash',
        close: 'fa fa-remove'
      }
    });
  }

  function initCharts() {
    console.log("initCharts()");
    var dataSales = {
      labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
      series: [
        [287, 385, 490, 492, 554, 586, 698, 695, 752, 788, 846, 944],
        [67, 152, 143, 240, 287, 335, 435, 437, 539, 542, 544, 647],
        [23, 113, 67, 108, 190, 239, 307, 308, 439, 410, 410, 509]
      ]
    };

    var optionsSales = {
      lineSmooth: false,
      low: 0,
      high: 800,
      showArea: true,
      height: "245px",
      axisX: {
        showGrid: false,
      },
      lineSmooth: Chartist.Interpolation.simple({
        divisor: 3
      }),
      showLine: false,
      showPoint: false,
    };

    var responsiveSales = [
      ['screen and (max-width: 640px)', {
        axisX: {
          labelInterpolationFnc: function(value) {
            return value[0];
          }
        }
      }]
    ];

    Chartist.Line('#chartHours', dataSales, optionsSales, responsiveSales);


    var data = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
        [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
      ]
    };

    var options = {
      seriesBarDistance: 10,
      axisX: {
        showGrid: false
      },
      height: "245px"
    };

    var responsiveOptions = [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function(value) {
            return value[0];
          }
        }
      }]
    ];

    Chartist.Bar('#chartActivity', data, options, responsiveOptions);

    var dataPreferences = {
      series: [
        [25, 30, 20, 25]
      ]
    };

    var optionsPreferences = {
      donut: true,
      donutWidth: 40,
      startAngle: 0,
      total: 100,
      showLabel: false,
      axisX: {
        showGrid: false
      }
    };

    Chartist.Pie('#chartPreferences', dataPreferences, optionsPreferences);

    Chartist.Pie('#chartPreferences', {
      labels: ['62%', '32%', '6%'],
      series: [62, 32, 6]
    });

    console.log("charts init done!");
  }

</script>



// WEBPACK FOOTER //
// t_createrfq.vue?04d84dbc